import React from 'react';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { MdModeEditOutline, MdPause } from 'react-icons/md';
import { FaTrash } from 'react-icons/fa';
import { IoIosMore } from 'react-icons/io';

type OfferActionModalProps = {
  onClose: () => void;
};

const OfferActionModal: React.FC<OfferActionModalProps> = ({ onClose }) => (
  <Modal
    visible
    autoHeight
    onClose={onClose}
    type={ModalType.SMALL}
    title="More Actions"
    icon={<IoIosMore size={20} />}
    renderFooter={() => (
      <div
        className="text-[#A4332A] justify-center self-center items-center my-1"
        onClick={() => null}
      >
        <div className="flex items-center justify-center text-base font-bold">
          <FaTrash size={14} className="mr-2" />
          Delete offer
        </div>
      </div>
    )}
  >
    <div className="mx-4">
      <div className="flex flex-col gap-2 mt-6">
        <Button
          type={ButtonType.Inverted}
          onClick={() => null}
          icon={
            <img
              src="/img/events/create/offer-blue.svg"
              height={16}
              width={16}
            />
          }
        >
          Offer Details
        </Button>
      </div>
      <div className="flex flex-col gap-2 mt-6">
        <Button
          type={ButtonType.Inverted}
          onClick={() => null}
          icon={<MdModeEditOutline size={20} />}
        >
          Edit offer
        </Button>
      </div>
      <div className="flex flex-col gap-2 mt-6">
        <Button
          type={ButtonType.Inverted}
          onClick={() => null}
          icon={<MdPause size={20} />}
        >
          Pause Offer
        </Button>
      </div>
    </div>
  </Modal>
);

export default OfferActionModal;
